module.exports = __webpack_public_path__ + "static/media/psbb-logo.5f351db0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/psbb-logo.jpg
 ** module id = 773
 ** module chunks = 0
 **/